import styled from "styled-components";

export const OpenModalLink = styled.a`
  cursor: pointer;
  color: #1f4ca0;
  font-weight: bold;
`;
